import { format } from 'date-fns';

export class TimeDateUtils {
    /** Formats the local calendar day. Avoid toISOString(), which shifts days for browsers ahead of UTC. */
    static getDay(date: Date): string {
        return format(date, 'yyyy-MM-dd');
    }

    static getHours(h: number | undefined): string {
        return !h ? '' : (h % 1 ? h.toFixed(1) : h.toFixed(0));
    }
}